import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

interface Props {
  onClick: () => void
  hidden?: boolean
}

const useStyles = makeStyles<Theme>(() => {
  return createStyles(
    {
      castGroup: {
        position: 'fixed',
        top: 58,
        right: 35,
        width: 400,
        height: 40,
        zIndex: 9999999,
        pointerEvents: 'auto',
        transition: 'opacity 0.3s, visibility 0.3s',
        visibility: 'visible',
      },
      hidden: {
        visibility: 'hidden',
        opacity: 0,
      },
      toggleButton: {
        backgroundColor: 'white',
        border: 'none',
        maskImage: 'url("data:image/svg+xml,%3C%3Fxml version=\'1.0\' encoding=\'UTF-8\'%3F%3E%3Csvg width=\'48px\' height=\'48px\' viewBox=\'0 0 48 48\' version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\'%3E%3Ctitle%3Eicon - chromecast%3C/title%3E%3Cdefs%3E%3Cpath d=\'M38.2347329,7.66666667 C41.4595785,7.66666667 44.0833333,10.3132199 44.0833333,13.5660868 L44.0833333,13.5660868 L44.0833333,33.3922465 C44.0833333,36.6451135 41.4595785,39.2916667 38.2347329,39.2916667 L38.2347329,39.2916667 L22.5190422,39.2916667 L22.5190422,35.4243215 L38.2347329,35.4243215 C39.3453237,35.4243215 40.2493029,34.5129172 40.2493029,33.3922465 L40.2493029,33.3922465 L40.2493029,13.5660868 C40.2493029,12.4454161 39.3453237,11.5340118 38.2347329,11.5340118 L38.2347329,11.5340118 L7.76569309,11.5340118 C6.65467627,11.5340118 5.7506971,12.4454161 5.7506971,13.5660868 L5.7506971,13.5660868 L5.7506971,18.6976241 L1.91666667,18.6976241 L1.91666667,13.5660868 C1.91666667,10.3132199 4.54042149,7.66666667 7.76569309,7.66666667 L7.76569309,7.66666667 Z M1.91666667,35.7777778 C3.85759659,35.7777778 5.43055556,37.3274602 5.43055556,39.2385226 L5.43055556,39.2385226 L1.91666667,39.2916667 Z M1.91666667,28.75 C7.7293376,28.75 12.4583333,33.4789957 12.4583333,39.2916667 L12.4583333,39.2916667 L8.64257561,39.2916667 C8.64257561,35.5827502 5.62558317,32.5657577 1.91666667,32.5657577 L1.91666667,32.5657577 Z M1.91666667,21.7222222 C11.6046379,21.7222222 19.4861111,29.6039294 19.4861111,39.2916667 L19.4861111,39.2916667 L15.6677734,39.2916667 C15.6677734,31.7090554 9.49903678,25.5404677 1.91666667,25.5404677 L1.91666667,25.5404677 Z\' id=\'path-1\'%3E%3C/path%3E%3C/defs%3E%3Cg id=\'icon---chromecast\' stroke=\'none\' stroke-width=\'1\' fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg id=\'icon-/-01-small-/-37-mirror-copy\' transform=\'translate(1.000000, 1.000000)\'%3E%3Cmask id=\'mask-2\' fill=\'white\'%3E%3Cuse xlink:href=\'%23path-1\'%3E%3C/use%3E%3C/mask%3E%3Cuse id=\'Combined-Shape\' fill=\'%23FFFFFF\' xlink:href=\'%23path-1\'%3E%3C/use%3E%3Cg id=\'Group\' mask=\'url(%23mask-2)\' fill=\'%23FFFFFF\'%3E%3Cg id=\'colour-/-D5D9DC\'%3E%3Crect id=\'Rectangle\' x=\'0\' y=\'0\' width=\'46\' height=\'46\'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
        position: 'fixed',
        top: 58,
        right: 35,
        height: 48,
        width: 48,
        padding: 8,
        cursor: 'pointer',
        opacity: 0.8,

        '&:hover, &:focus': {
          opacity: 1,
        },
        '&:focus-visible': {
          boxShadow: '0 0 0 3px #ff0000',
        },
      },

    },
  );
});

const ChromeCastIcon: React.FC<Props> = ({ onClick, hidden = false }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.castGroup, hidden && classes.hidden)}>
      <div>
        <button
          className={clsx(classes.toggleButton)}
          type="button"
          aria-label="Chrome Cast"
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default ChromeCastIcon;
